import { ConfirmationModal, Spinner } from '@frontend/elements';
import { CommonMessage } from '@frontend/lang';
import { Layout } from '@frontend/spot-layout';
import { addCommandHistory } from '@frontend/terminal/shared';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import SlotOpening from '../slot-status/slot-opening/slot-opening.component';
import { UserInterfaceProps } from '../types/user-interface';
import useOpenDropoffCouriers, { ViewProps } from './open-dropoff-couriers.controller';

export const OpenDropoffCouriers = (props: UserInterfaceProps) => {
    const viewProps = useOpenDropoffCouriers(props);

    if (viewProps.isDropping && viewProps.transaction && viewProps.transaction.slot_id) {
        return (
            <SlotOpening
                data={{
                    slot_id: viewProps.transaction.slot_id
                }}
            />
        );
    }

    if (viewProps.selectedUser && viewProps.spot) {
        return (
            <>
                <div className='vh-75'>
                    <Layout
                        spot={viewProps.spot}
                        renderingProps={{
                            moduleRenderingProps: {
                                slotRenderingProps: {
                                    onClick: (sr) => {
                                        const id = sr.slot_ids[0];
                                        if (!viewProps.disabledSlots.find((s) => s.id === id)) viewProps.setSlot(id);
                                    },
                                    styles: {
                                        div: (sr) => {
                                            if (viewProps.slot && viewProps.slot === sr.slot_ids[0]) {
                                                return `spotlayout-item spotlayout-item-success align-items-center justify-content-center w-100 h-100`;
                                            }
                                            const value = viewProps.slotMap.get(sr.slot_ids[0]);
                                            return `spotlayout-item spotlayout-item-${value ?? 'secondary'} align-items-center justify-content-center w-100 h-100`;
                                        }
                                    },
                                    label: (sr) => {
                                        return viewProps.slotList.find((s) => s.id === sr.slot_ids[0])?.display ?? '';
                                    }
                                }
                            }
                        }}
                    />
                </div>
                {viewProps.slot && (
                    <ConfirmationModal
                        message={
                            <FormattedMessage
                                id='open-dropoff-couriers.drop-off-message'
                                defaultMessage='Are you sure you want to drop off your package in this SLOT?'
                            />
                        }
                        onConfirm={viewProps.onDropOff}
                        handleClose={() => viewProps.setSlot(null)}
                        show={!!viewProps.slot}
                    />
                )}
            </>
        );
    }

    if (viewProps.selectedSender) {
        return (
            <div className='d-flex flex-column justify-content-between fs-5 w-100 p-1'>
                <div className=''>
                    <div className='d-flex justify-content-center flex-row'>
                        <h3>
                            <FormattedMessage
                                id='open-dropoff-couriers.select-receiver'
                                defaultMessage='Choose a receiver'
                            />
                        </h3>
                    </div>
                    <div className='d-flex justify-content-center w-100 flex-row'>
                        <ul className='list-group m-1 w-100'>
                            <li className='list-group-item list-group-item-primary'>{CommonMessage.OBJECTS.CONTACT.PLURAL}</li>
                            {viewProps.users.map((user) => (
                                <li
                                    className='list-group-item list-group-item'
                                    key={user.id}
                                    onClick={() => {
                                        viewProps.setSelectedUser(user);
                                        props.dispatch(addCommandHistory(() => viewProps.setSelectedUser(null)));
                                    }}>
                                    <span className='d-flex justify-content-between flex-row'>
                                        <span className='d-flex align-items-center flex-row'>
                                            {user.first_name} {user.last_name}
                                        </span>
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

    return senderSelect(viewProps, props.dispatch);
};

const senderSelect = (viewProps: ViewProps, dispatch: ThunkDispatch<any, any, Action>) => {
    if (viewProps.isLoading) {
        return <Spinner />;
    }
    return (
        <div>
            <div className='d-flex justify-content-center flex-row'>
                <h3>
                    <FormattedMessage
                        id='open-dropoff-couriers.select-courier'
                        defaultMessage='Choose a courier'
                    />
                </h3>
            </div>
            <div className='d-flex flex-column'>
                <div className='d-flex justify-content-center flex-row flex-wrap'>
                    {viewProps.senders.map((sender) => (
                        <div
                            key={sender.id}
                            className='card m-2 w-45'
                            onClick={() => {
                                viewProps.setSelectedSender(sender);
                                dispatch(addCommandHistory(() => viewProps.setSelectedSender(null)));
                            }}>
                            <div className='card-body d-flex justify-content-center'>
                                {!sender.url ? (
                                    <span>
                                        {sender.first_name ?? ''} {sender.last_name ?? ''}
                                    </span>
                                ) : (
                                    <img
                                        className='img-fluid border-radius-lg max-height-300 shadow-lg'
                                        src={sender.url}
                                    />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
